import Vue from 'vue';

export const ShortDayNameFromList = 
  Vue.filter('shortDayNameFromList', (days: string[]) => {
    return days.map((d) => d.substring(0, 3)).join(', ');
  }
);
